module.exports = __webpack_public_path__ + "img/icon-legal.784a7ceb.png";